import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IMarque from '../../models/IMarque';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionMarquesProps {
  isModeSelection?: boolean;
}

class Marque extends IBaseModel implements IMarque {
  idMarque: Guid = Guid.empty;
}

export default function GestionMarques({ isModeSelection }: IGestionMarquesProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="Marque" model={Marque} />
  );
}